/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceBandResponse
 */
export interface PriceBandResponse {
    /**
     * 
     * @type {number}
     * @memberof PriceBandResponse
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceBandResponse
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceBandResponse
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceBandResponse
     */
    max?: number;
}

export function PriceBandResponseFromJSON(json: any): PriceBandResponse {
    return PriceBandResponseFromJSONTyped(json, false);
}

export function PriceBandResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceBandResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'percentage': !exists(json, 'percentage') ? undefined : json['percentage'],
        'min': !exists(json, 'min') ? undefined : json['min'],
        'max': !exists(json, 'max') ? undefined : json['max'],
    };
}

export function PriceBandResponseToJSON(value?: PriceBandResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'percentage': value.percentage,
        'min': value.min,
        'max': value.max,
    };
}


